import { render, staticRenderFns } from "./DemoBlock.vue?vue&type=template&id=7f8189f4&"
import script from "./DemoBlock.vue?vue&type=script&lang=js&"
export * from "./DemoBlock.vue?vue&type=script&lang=js&"
import style0 from "./DemoBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports